// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import router from './router';
import axiox from './axios/axios';
import VueResource from 'vue-resource';
import axios from 'axios';
import api from "./interface";
import preventReClick from './preventReClick' //防多次点击，重复提交
import 'lib-flexible/flexible'
import VuePhotoZoomPro from 'vue-photo-zoom-pro'//放大器
import template from './components/common/template.vue'//全局数据
Vue.prototype.template = template.listdata;
Vue.prototype.$api = api.commonUrl

Vue.config.productionTip = false
Vue.prototype.$http = axiox
Vue.use(VueResource)
Vue.use(ElementUI);
Vue.use(VuePhotoZoomPro)
// Vue.component("BannerPage",BannerPage)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js